module.exports = __webpack_public_path__ + "img/caiji-youshi-1-2.364b30e6.png";